var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 225,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M110.537 14.339 66.624 27.074 9.404 81.652l65.935 109.68s43.167 35.199 82.311 31.898l16.343-35.92-63.447-172.988-.009.017Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.668 223.513c5.026.071 7.971-.264 7.971-.264s-2.947.449-7.971.264Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m66.932 14.714 37.475.945-78.593 55.812c-5.455 3.872-7.147 11.224-3.926 17.097l36.906 67.242c32.35 58.946 73.756 67.046 90.882 67.693-20.15-.286-73.938-7.095-107.43-68.114L4.607 86.804A13.18 13.18 0 0 1 7.14 70.851l59.8-56.146-.008.009Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M42.247 155.398 4.605 86.813a13.073 13.073 0 0 1-1.603-5.82l17.272 1.276c.001 2.14.523 4.307 1.613 6.308l36.906 67.242c32.35 58.946 73.757 67.046 90.882 67.693-20.15-.286-73.937-7.095-107.428-68.114Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M4.605 86.814a13.074 13.074 0 0 1-1.603-5.821l17.272 1.276c.001 2.14.523 4.307 1.613 6.308l26.754 48.746-20.14-6.952L4.598 86.822l.008-.008Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m55.943 150.615-20.139-6.951-3.592-6.549 20.139 6.951 3.592 6.549Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.616,
    d: "M149.668 223.513c5.026.071 7.971-.264 7.971-.264s-2.947.449-7.971.264ZM66.932 14.714l37.475.945-78.593 55.812c-5.455 3.872-7.147 11.224-3.926 17.097l36.906 67.242c32.35 58.946 73.756 67.046 90.882 67.693-20.15-.286-73.938-7.095-107.43-68.114L4.607 86.804A13.18 13.18 0 0 1 7.14 70.851l59.8-56.146-.008.009Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.616,
    d: "M149.668 223.513c5.026.071 7.971-.264 7.971-.264s-2.947.449-7.971.264Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.616,
    d: "M58.8 155.819 21.894 88.577c-3.22-5.873-1.538-13.225 3.926-17.097l78.593-55.812 31.628 84.057c31.269 83.119 21.621 123.532 21.621 123.532s-2.945.335-7.972.264c-17.126-.647-58.532-8.747-90.882-67.693l-.008-.009Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F7",
    d: "M136.027 99.716 104.4 15.66l35.577-12.528a10.345 10.345 0 0 1 13.115 6.117l28.056 74.584c31.268 83.119-23.508 139.424-23.508 139.424s9.656-40.404-21.621-123.532l.008-.009Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D9FFF",
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.616,
    d: "M141.99 2.502 104.402 15.66l-37.467-.945 58.508-12.633 16.547.42Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m151.476 149.257 37.132-38.609c12.256 68.181-30.962 112.6-30.962 112.6s5.79-24.306-6.171-73.956l.001-.035Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m186.093 99.287-35.614 45.96-2.112-7.709 32.78-53.714 4.946 15.463Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0500FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.616,
    d: "M136.027 99.716 104.4 15.66l35.577-12.528a10.345 10.345 0 0 1 13.115 6.117l28.056 74.584c31.268 83.119-23.508 139.424-23.508 139.424s9.656-40.404-21.621-123.532l.008-.009Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 117.148,
    x2: 40.47,
    y1: 122.395,
    y2: 164.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 129.959,
    x2: 93.163,
    y1: 50.855,
    y2: 119.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0500FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0912FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1541FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#288CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 59.472,
    x2: 97.106,
    y1: 119.805,
    y2: 195.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0500FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0912FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1541FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#288CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.653,
    x2: 28.494,
    y1: 86.545,
    y2: 124.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 33.302,
    x2: 40.144,
    y1: 84.432,
    y2: 122.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 147.906,
    x2: 197.162,
    y1: 139.106,
    y2: 193.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0500FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0912FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1541FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#288CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 169.955,
    x2: 219.21,
    y1: 119.104,
    y2: 173.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0500FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0912FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1541FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#288CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs2);
export default __webpack_public_path__ + "static/media/ps-2.e0bf81a8d33e59b3335b84e5a9f2193e.svg";
export { ForwardRef as ReactComponent };